<script lang="ts">
	const faqs = [
		[
			{
				question: 'What is Airheart?',
				answer:
					'Airheart is a designated platform that empowers travel creators to monetize their expertise by offering digital guides for purchase, acting as a bridge between modern travelers and trusted travel guidance.',
			},
			{
				question: 'How do I sign up as a creator?',
				answer:
					'Currently invite-only. During the intial launch phase, we are curating a community of travel creators to ensure high-quality content and a seamless user experience.',
			},
			{
				question: 'Can anyone sell travel guides on Airheart?',
				answer:
					'Currently invite-only. During the intial launch phase, we are curating a community of travel creators to ensure high-quality content and a seamless user experience.',
			},
		],
		[
			{
				question: 'How do I price my guide?',
				answer:
					'You have complete control over your pricing, but it has to be at least $5.99 USD. We recommend researching similar guides to ensure competitive pricing, but the final decision rests with you.',
			},
			{
				question: 'What makes Airheart different from other travel platforms?',
				answer:
					'Airheart is uniquely tailored for the travel content creator market, providing specialized tools for guide creation and a community-driven focus, all while ensuring creators enjoy generous profits.',
			},
			{
				question: 'How does Airheart handle SEO? (soon)',
				answer:
					"We've optimized our platform to ensure your guides rank higher on search engines and our marketplace, driving organic traffic to your content and making it easier for travelers to find you.",
			},
		],
		[
			{
				question: 'Can I include affiliate links in my guide?',
				answer:
					'Absolutely! Integrate your affiliate links to earn additional commissions on related bookings.',
			},
			{
				question: 'How do payments work on Airheart?',
				answer:
					'Creators receive a significant 80% of the profits from their sold guides. Payments are processed securely and are disbursed on a daily basis.',
			},
			{
				question: 'What tools does Airheart offer for guide creation?',
				answer:
					'Airheart provides specialized tools tailored for travel guide creation, including intuitive AI that helps convert your existing content into comprehensive guides (coming soon).',
			},
		],
	]
</script>

<section
	id="faqs"
	aria-labelledby="faqs-title"
	class="relative isolate border-t border-brand-gray-4 py-20 sm:py-32 lg:pt-36"
	data-testid="Faq"
>
	<!-- <div
		class="absolute inset-x-0 top-4 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
		aria-hidden="true"
	>
		<div
			class="aspect-[1108/632] w-[69.25rem] flex-none bg-gradient-to-l from-brand-primary-50 to-brand-gray-3 opacity-25"
			style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)"
		/>
	</div> -->
	<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
		<div class="mx-auto max-w-2xl lg:max-w-3xl lg:mx-0">
			<h2 id="faqs-title" class="text-3xl lg:text-4xl font-bold tracking-tight text-brand-gray-6">
				You Have Questions, We Have Answers
			</h2>
			<p class="mt-2 text-lg text-brand-gray-5">
				If you have anything else you want to ask,{' '}
				<a href="mailto:support@airheart.com" class="text-brand-gray-6 underline">
					reach out to us</a
				>
			</p>
		</div>
		<ul
			role="list"
			class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:mt-20 lg:max-w-none lg:grid-cols-3"
		>
			{#each faqs as column}
				<li>
					<ul role="list" class="space-y-10">
						{#each column as faq}
							<li>
								<h3 class="text-lg font-semibold leading-6 text-brand-gray-6">
									{faq.question}
								</h3>
								<p class="mt-4 text-sm text-gray-700">{faq.answer}</p>
							</li>
						{/each}
					</ul>
				</li>
			{/each}
		</ul>
	</div>
</section>
